import {Step} from 'react-joyride';
import {tourText} from '../../texts/createLearnersText';
import {stepConfig} from './createLearnersStepConfig';
import {buildSteps} from '../../utils/buildSteps';

export const getCreateLearnersSteps = (): Step[] =>
  buildSteps(stepConfig, tourText, 'Invite learners');
